module.exports = __webpack_public_path__ + "static/media/css3.5a1a5947.svg";